import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Grid } from "@material-ui/core";
import mutations from "Shared/mutations";
import {
  ExportPayrollExtenderReportMutation,
  ExportPayrollExtenderReportMutationVariables,
} from "generated/graphql";
import { errorToast, successToast } from "Modules/DPToast";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { DPExportButton } from "Components/DP";

export const BalanceDistributorActions = () => {
  const { permissions } = usePartnerConfig();
  const [exportReportFn] = useMutation<
    ExportPayrollExtenderReportMutation,
    ExportPayrollExtenderReportMutationVariables
  >(mutations.EXPORT_BALANCE_DISTRIBUTOR_REPORT);

  const [disableExportButton, setDisableExportButton] = useState(false);

  const handleExportButtonClick = async () => {
    setDisableExportButton(true);
    try {
      const exportResponse = await exportReportFn();
      successToast(exportResponse.data!.exportPayrollExtenderReport.message);
    } catch (e) {
      setDisableExportButton(true);
      errorToast("Failed to export report.");
    }
  };

  return (
    <Grid item xs={12} container justify="flex-end">
      {permissions.canGeneratePayrollExtenderReports && (
        <DPExportButton
          handleExport={handleExportButtonClick}
          disabled={disableExportButton}
          size="large"
        />
      )}
    </Grid>
  );
};
